import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17 11.78v1.388a3 3 0 0 1 1.994 3.024l1.276.547q.063-.361.063-.742A4.335 4.335 0 0 0 17 11.78M15 11.78a4.335 4.335 0 0 0-3.27 4.96l1.276-.547A3.001 3.001 0 0 1 15 13.168zM19.482 18.578l-1.276-.547a3 3 0 0 1-2.206.966 3 3 0 0 1-2.206-.966l-1.276.547A4.33 4.33 0 0 0 16 20.33c1.427 0 2.692-.69 3.482-1.753"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M17.407 5.664h-2.813c-1.824 0-3.294 0-4.45.155-1.2.162-2.21.507-3.013 1.31-.37.37-.644.785-.846 1.243A1 1 0 0 0 5 9.33v4a1 1 0 0 0 .667.943v3.447a1 1 0 0 0-.667.943v4a1 1 0 0 0 1.285.959c.202.457.475.873.846 1.243.803.803 1.813 1.148 3.013 1.31 1.156.155 2.626.155 4.45.155h2.813c1.823 0 3.293 0 4.449-.156 1.2-.161 2.21-.506 3.013-1.309s1.148-1.813 1.309-3.013c.155-1.156.155-2.626.155-4.45v-2.812c0-1.824 0-3.293-.155-4.45-.161-1.2-.507-2.21-1.31-3.012-.802-.803-1.812-1.148-3.012-1.31-1.156-.155-2.626-.155-4.45-.155m-7.74 10.333a6.333 6.333 0 1 1 12.666 0 6.333 6.333 0 0 1-12.666 0",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.62 4.617c-1.953 1.952-1.953 5.095-1.953 11.38s0 9.429 1.953 11.381c1.952 1.953 5.095 1.953 11.38 1.953s9.428 0 11.381-1.953 1.953-5.095 1.953-11.38 0-9.429-1.953-11.381c-1.953-1.953-5.095-1.953-11.38-1.953s-9.429 0-11.381 1.953m9.974 1.047h2.813c1.823 0 3.293 0 4.449.155 1.2.162 2.21.507 3.013 1.31.803.802 1.148 1.813 1.31 3.013.155 1.156.155 2.625.155 4.449v2.813c0 1.823 0 3.293-.156 4.45-.161 1.2-.506 2.21-1.309 3.012-.802.803-1.813 1.148-3.013 1.31-1.156.155-2.626.155-4.45.155h-2.812c-1.824 0-3.293 0-4.45-.156-1.2-.161-2.21-.506-3.013-1.309a4 4 0 0 1-.846-1.243A1 1 0 0 1 5 22.664v-4a1 1 0 0 1 .667-.943v-3.447A1 1 0 0 1 5 13.33v-4a1 1 0 0 1 1.285-.96c.203-.457.476-.872.846-1.242.803-.803 1.814-1.148 3.014-1.31 1.156-.155 2.625-.155 4.449-.155",
      "clip-rule": "evenodd",
      opacity: ".5"
    }, null, -1)
  ])))
}
export default { render: render }